export default __webpack_public_path__ + "static/media/closeIcon.7423c9a6.svg";